import { render, staticRenderFns } from "./SdsTableSection2List.vue?vue&type=template&id=0e2e8b5e"
import script from "./SdsTableSection2List.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection2List.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection2List.vue?vue&type=style&index=0&id=0e2e8b5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports